import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
  Title,
  WidgetCalculatorContainer,
  WidgetCalculatorWrapper,
  WidgetCalculatorSection,
  ParcelTabsContainer,
  CalculatorSubtitle,
} from './widget-calculator.styles';
import { SectionSubtitle } from '../common/typography.styles';
import { theme } from '../../../styles/themes';
import { getTabs, WidgetTabs } from './config';
import { useStore } from '../../../stores/store';
import { isFeatureRequired } from '../../../utils/client/client.utils';

const WidgetCalculator = () => {
  const {
    localizationsStore: { selectedCountry },
    marketingStore: { countriesWithDomestic },
  } = useStore();

  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState<WidgetTabs>('calculator');

  const domesticAllowed = countriesWithDomestic.includes(
    selectedCountry?.country_code ?? ''
  );

  const tabs = getTabs(
    activeTab,
    setActiveTab,
    t,
    domesticAllowed,
    selectedCountry?.flag_image_svg
  );

  const getMainPageSubTitle = () =>
    isFeatureRequired('mainPageSubtitleEasyParcelShipping')
      ? t('main_page_title_easy_parcel_shipping')
      : t('main_page_title_international_shipping_worldwide');

  return (
    <WidgetCalculatorWrapper>
      <WidgetCalculatorSection>
        <WidgetCalculatorContainer>
          <SectionSubtitle $color={theme.colors.namedColors.white}>
            {t('main_page_title_meest_portal')}
          </SectionSubtitle>
          <Title>{getMainPageSubTitle()}</Title>
          <CalculatorSubtitle>
            {t('main_page_subtitle_international_domestic')}
          </CalculatorSubtitle>
          <ParcelTabsContainer>
            {tabs.map((tab) => tab.tab)}
          </ParcelTabsContainer>
          {tabs.map((tab) => tab.element)}
        </WidgetCalculatorContainer>
      </WidgetCalculatorSection>
    </WidgetCalculatorWrapper>
  );
};

export default observer(WidgetCalculator);
